export const ViewerOnMessageReceivedEvent = 'ChatWidget.onMessageReceived';
export const ViewerOnMessageSentEvent = 'ChatWidget.onMessageSent';
export const ViewerOnWidgetCollapsed = 'ChatWidget.onWidgetCollapsed';
export const ViewerOnWidgetExpand = 'ChatWidget.onWidgetExpand';
